var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyxdLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.4733 16.5835C34.613 17.7231 35.7526 18.8628 35.7526 18.8628C37.2877 17.3277 37.2954 15.8004 35.7759 14.2809C34.6363 13.1412 33.8765 12.3815 33.8804 11.6178C31.9616 13.5367 31.9538 15.064 33.4733 16.5835Z",
    fill: "url(#paint0_linear_4474_33335)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M33.8067 26.1271C33.8105 25.3635 34.5781 24.5959 35.7294 23.4446C37.2645 21.9096 37.2722 20.3823 35.7527 18.8627C35.7527 18.8627 34.6014 20.014 33.4501 21.1653C31.915 22.7004 31.9073 24.2277 33.8067 26.1271Z",
    fill: "url(#paint1_linear_4474_33335)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5232 3.26057C24.7595 3.26446 23.9998 2.5047 22.8602 1.36507C21.3406 -0.154448 19.8133 -0.146672 18.2783 1.3884C18.2783 1.3884 19.4179 2.52803 20.5576 3.66767C22.0771 5.18718 23.6044 5.17941 25.5232 3.26057Z",
    fill: "url(#paint2_linear_4474_33335)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M15.9757 3.69095C17.127 2.53964 18.2783 1.38834 18.2783 1.38834C16.7588 -0.131171 15.2315 -0.123395 13.6964 1.41167C12.5451 2.56297 11.7776 3.33051 11.014 3.3344C12.9134 5.23379 14.4407 5.22601 15.9757 3.69095Z",
    fill: "url(#paint3_linear_4474_33335)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M33.8805 11.6179C35.7994 9.69904 35.8071 8.17175 33.5279 5.89247L31.2486 3.6132C28.9693 1.33393 27.442 1.3417 25.5232 3.26054C26.2868 3.25665 27.4431 4.37965 28.946 5.9158L31.2253 8.19507C32.7286 9.73079 33.8844 10.8542 33.8805 11.6179Z",
    fill: "url(#paint4_linear_4474_33335)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0139 3.33443C9.11452 1.43503 7.58723 1.44281 5.28463 3.74541L2.98203 6.04801C0.679424 8.35062 0.671648 9.87791 2.57104 11.7773C2.57493 11.0137 3.70977 9.84589 5.2613 8.32729L7.5639 6.02468C9.11501 4.50566 10.2503 3.33832 11.0139 3.33443Z",
    fill: "url(#paint5_linear_4474_33335)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.364 34.57C27.2634 36.4694 28.7907 36.4616 31.0933 34.159L33.3959 31.8564C35.6985 29.5538 35.7063 28.0266 33.8069 26.1272C33.803 26.8908 32.6682 28.0586 31.1167 29.5772L28.8141 31.8798C27.2629 33.3988 26.1277 34.5661 25.364 34.57Z",
    fill: "url(#paint6_linear_4474_33335)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 10.8036H17.0838C18.9606 10.8036 20.5981 11.1648 21.9963 11.8837C23.3946 12.6061 24.4795 13.6397 25.2477 14.988C26.016 16.3363 26.4 17.9099 26.4 19.7124C26.4 22.6987 25.5678 24.9625 23.9 26.4968C22.2356 28.0347 19.9444 28.8 17.0333 28.8H10.8V10.8V10.8036ZM17.3972 24.3224C18.6438 24.3224 19.6007 23.9111 20.2712 23.0849C20.9417 22.2624 21.2787 21.1358 21.2787 19.7124C21.2787 18.4428 20.9384 17.3877 20.2611 16.5437C19.5839 15.6997 18.6506 15.2812 17.4713 15.2812H15.8204V24.3188H17.3972V24.3224Z",
    fill: "url(#paint7_linear_4474_33335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4474_33335",
    x1: 36.1599,
    y1: 13.8974,
    x2: 33.4736,
    y2: 16.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4474_33335",
    x1: 37.0824,
    y1: 20.1925,
    x2: 32.4772,
    y2: 24.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4474_33335",
    x1: 23.2442,
    y1: 0.98155,
    x2: 20.5578,
    y2: 3.66792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4474_33335",
    x1: 16.9489,
    y1: 0.058913,
    x2: 12.3437,
    y2: 4.66412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4474_33335",
    x1: 32.3887,
    y1: 4.75329,
    x2: 29.7023,
    y2: 7.43966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4474_33335",
    x1: 9.68449,
    y1: 2.005,
    x2: 1.24161,
    y2: 10.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4474_33335",
    x1: 35.1366,
    y1: 27.4569,
    x2: 26.6938,
    y2: 35.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4474_33335",
    x1: 10.8,
    y1: 19.799,
    x2: 26.4,
    y2: 19.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyxdLogoBlue);
export default __webpack_public_path__ + "static/media/fyxd-logo-blue.e06e292a716419c7094cdffcd1a6fab7.svg";
export { ForwardRef as ReactComponent };